
import { color } from "theme/Color";
import { typography } from "theme/Typography";

export const styles = {
    MainRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "91vh",
    },

    ErrorMsg: {
        color: color.DANGER,
        fontSize: typography.fontSizes.xs,
        marginTop: -22,
    }
}